import { SelectInput } from '../../SelectInput';

const defaultPagesInterval = [
    { id: "25", name: '25'},
    { id: "50", name: '50' },
    { id: "100", name: '100' }
];

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export const TablePaginator = ({
    onNextPage= ()=>{},
    onPreviousPage= ()=>{},
    onSelectRangePage= ()=>{},
    canNextPage = false,
    canPreviousPage = false,
    tableTitle = "",
    pageIndex = 0,
    pageCount = 1,
    pagesSize = 0,
    rowsCount = 0,
    countCapped = false,
    totalUnknown = false,
    showCount = true,
    buttonText,
    buttonOnClick,
    hideBorders = false,
    pageSizeOptions = defaultPagesInterval,
    leftTitle = ""
}) => {

   return (
       <nav className={classNames(hideBorders ? '' : 'border', 'bg-white px-4 py-3 flex justify-between items-center sm:px-0')} aria-label="Pagination">
           {/* Title ml-6 matches the table cells' px-6, so it lines up with the first column. */}
           {leftTitle &&
               <h1 className="text-lg ml-6 leading-6 font-medium text-gray-900 flex-shrink-0">{leftTitle}</h1>
           }
           {buttonText &&
               <div className="ml-4 mt-1 flex-shrink-0">
                   <button
                       type="button"
                       className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-white text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                       onClick={buttonOnClick}
                   >
                       {buttonText}
                   </button>
               </div>
           }
           <div className="flex-1 flex items-center justify-between px-6 sm:justify-end">
                <div className=''>
                    <span className="text-sm text-gray-700 text-center flex ml-10 sm:col-span-3 sm:ml-0">
                        <label className='inline-flex items-center ml-1 sm:mr-3'>{tableTitle} por página </label>
                        <SelectInput
                            options={pageSizeOptions}
                            selectedInitial={pageSizeOptions.find(option => option.id === pagesSize) ?? pageSizeOptions[0]}
                            label=''
                            className="inline-flex text-sm items-center px-4 sm:px-0"
                            onChange={(page) => {
                                onSelectRangePage(page.id)
                            }}
                            value={pageSizeOptions.find(option => option.id === pagesSize) ?? pageSizeOptions[0]}
                        />
                    </span>
                </div>
                {/* No mt offsets here: the nav row centers vertically (items-center),
                    so ad-hoc top margins pushed the controls below the left title. */}
                <div className="hidden sm:block mr-5 sm:ml-3">
                    <div className="text-sm text-gray-700">
                        {/* null, not <p></p>: an empty block element adds a phantom second
                            line that pushes "Página N de M" above the row's vertical center. */}
                        Página <span className="text-sm text-gray-700 font-semibold">{pageIndex+1}</span>
                        {totalUnknown ? null : <> de <span className="text-sm text-gray-700 font-semibold">{pageCount}</span></>}
                        {showCount && !totalUnknown ? <label>, elementos totales <span className="font-medium font-semibold">{rowsCount}{countCapped ? "+" : ""}</span></label> : null}
                    </div>
                </div>
                <div>
                <a
                    onClick={() => {canPreviousPage && onPreviousPage() }}
                    disabled={ !canPreviousPage }
                    className="cursor-pointer relative inline-flex items-center px-2 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 has-tooltip"
                >
                    <span className="tooltip rounded shadow-lg p-1.5 bg-black text-white -mt-12">
                        Anterior
                    </span>
                    {"<"}
                </a>
                <a
                    onClick={() =>{ canNextPage && onNextPage() }}
                    disabled={ !canNextPage }
                    className="cursor-pointer ml-3 relative inline-flex items-center px-2 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 has-tooltip"
                >
                    <span className="tooltip rounded shadow-lg p-1.5 bg-black text-white -mt-12">
                        Siguiente
                    </span>

                    {">"}
                </a>
               </div>
           </div>
       </nav>
   )
}